var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"100px auto","text-align":"center"}},[_c('div',{staticClass:"lds-dual-ring"},[_vm._v("Đang thoát...")])])
}]

export { render, staticRenderFns }